export default "__VITE_ASSET__fe1dab49__"